import { useAdministrationContext } from '@openx/components-administration/lib/utils/context/AdministrationContext';
import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { PageNotFound } from '@openx/components-core/lib/PageNotFound/PageNotFound';
import type { UsersRouteParams } from '@openx/types/user';
import { useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context';
import { isAdmin } from '../../permissions/validators';
import { UserCreateForm } from './components/UserForm/UserCreateForm';
import { UserEditForm } from './components/UserForm/UserEditForm';

export const UserFormPage = () => {
  const { session } = useAuth();
  const { userId = '' } = useParams<UsersRouteParams>();
  const isAllowed = isAdmin(session);
  const { useUserFetch } = useAdministrationContext();
  const { user, loading } = useUserFetch(userId);

  if (!isAllowed) return <AccessForbiddenPage />;
  if (loading) return <Loader />;
  if (!userId) return <UserCreateForm />;
  if (!user) return <PageNotFound appName={'OpenXSelect'} />;

  return <UserEditForm currentUser={user} userId={userId} />;
};
